// file manager, login, 学习资源库, plan card / lists / hierarchy, 回收站
const en = {
  // lesson-file-manager
  "\"{file.name}\" 已存在，是否替换？": "\"{file.name}\" already exists. Replace it?",
  "加载文件夹列表失败。": "Failed to load folders.",
  "加载附件列表失败。": "Failed to load files.",
  "已上传 {uploadedCount} 个文件。": "Uploaded {uploadedCount} files.",
  "已上传 {uploadedCount} 个文件，跳过 {1} 个。": "Uploaded {uploadedCount} files, skipped {1}.",
  "新建文件夹失败。": "Failed to create the folder.",
  "重命名失败。": "Rename failed.",
  "预览：": "Preview: ",
  "预览加载中...": "Loading preview...",
  "<p>文档内容为空。</p>": "<p>The document is empty.</p>",
  "预览失败。若为 .doc 文件，请使用下载。": "Preview failed. For .doc files, please download instead.",
  "下载失败。": "Download failed.",
  "课时{lessonIndex}-支撑材料.zip": "lesson{lessonIndex}-materials.zip",
  "材料.zip": "materials.zip",
  "打包下载失败。": "Zip download failed.",
  "此操作将永久删除已选择的 {selectionCount} 项{1}，且无法撤销。确定继续吗？":
    "This will permanently delete the {selectionCount} selected items{1} and cannot be undone. Continue?",
  "（含文件夹内的所有内容）": " (including everything inside the folders)",
  "删除成功。": "Deleted.",
  "移动失败。": "Move failed.",
  "未能从该文件提取到可用于知识库/知识卡片的文本内容——可能是扫描件、没有文字层，或提取仍在后台处理中，可稍后刷新页面重试。":
    "No usable text could be extracted from this file for the knowledge base / knowledge card. It may be a scan without a text layer, or extraction may still be running in the background; refresh later to retry.",
  "文件夹": "Folder",
  "根目录": "Root",
  "上传": " Upload",
  "新建文件夹": " New folder",
  "列表视图": "List view",
  "图标视图": "Icon view",
  "文件夹名称": "Folder name",
  "已选择 {selectionCount} 项": "{selectionCount} selected",
  "预览": "Preview",
  "重命名": "Rename",
  "移动到...": "Move to...",
  "上传中...": "Uploading... ",
  "此文件夹为空 -- 将文件或文件夹拖拽到此处，或点击上方“上传”": "This folder is empty. Drag files or folders here, or click \"Upload\" above",
  "此文件夹为空": "This folder is empty",
  "名称": "Name",
  "类型": "Type",
  "大小": "Size",
  "修改时间": "Modified",
  "（此文件夹下没有子文件夹）": "(no subfolders)",
  "移动到此处": "Move here",

  // login
  "必须填写!": "Required!",
  "服务器异常，登录失败。": "Server error, login failed.",
  "登录失败，请确认用户名/密码正确。": "Login failed. Please check your username and password.",
  "欢迎回来": "Welcome back",
  "忘记密码？": "Forgot password?",
  "还没有账号？": "No account yet?",
  "立即注册": "Sign up now",

  // materials-library
  "使用指南": "User guides",
  "教师手册": "Teacher manual",
  "材料内容": "Materials",
  "视频链接": "Video links",
  "知识卡片": "Knowledge card",
  "加载学习资源库失败。": "Failed to load the Resource Library.",
  "教师手册下载失败。": "Teacher manual download failed.",
  "教师手册已发布。": "Teacher manual published.",
  "教师手册发布失败。": "Failed to publish the teacher manual.",
  "加载视频链接失败。": "Failed to load video links.",
  "加载知识卡片失败。": "Failed to load the knowledge card.",
  "本主题下暂无手册文档。": "No manual document in this topic yet.",
  "加载手册内容失败。": "Failed to load the manual.",
  "基本信息已保存。": "Basic info saved.",
  "保存失败。": "Save failed.",
  "知识卡片已重新生成。": "Knowledge card regenerated.",
  "生成知识卡片失败。": "Failed to generate the knowledge card.",
  "此操作将永久删除该主题及其所有材料内容和链接，且无法撤销。确定继续吗？":
    "This will permanently delete this topic with all its materials and links and cannot be undone. Continue?",
  "主题已删除。": "Topic deleted.",
  "请填写分类和主题名称。": "Please enter a category and topic name.",
  "创建主题失败。": "Failed to create the topic.",
  "重命名分类失败。": "Failed to rename the category.",
  "此操作将永久删除分类「{category}」下的全部 {topicCount} 个主题及其所有材料内容和链接，且无法撤销。确定继续吗？":
    "This will permanently delete all {topicCount} topics in category \"{category}\" with all their materials and links, and cannot be undone. Continue?",
  "分类已删除。": "Category deleted.",
  "删除分类失败。": "Failed to delete the category.",
  "请填写链接地址。": "Please enter a URL.",
  "添加链接失败。": "Failed to add the link.",
  "更新链接失败。": "Failed to update the link.",
  "确定删除该链接吗？": "Delete this link?",
  "删除链接失败。": "Failed to delete the link.",
  "知识卡片已保存。": "Knowledge card saved.",
  "保存知识卡片失败。": "Failed to save the knowledge card.",
  "搜索失败。": "Search failed.",
  "分类": "Category",
  "选择或输入新分类...": "Choose or type a new category...",
  "新建分类：{input}": "New category: {input}",
  "主题": "Theme",
  "主讲人": "Speaker",
  "备注": "Notes",
  "强制生成知识卡片": "Force-regenerate knowledge card",
  "删除本主题": "Delete this topic",
  "暂无视频链接。": "No video links yet.",
  "链接描述": "Link description",
  "链接地址": "URL",
  "添加链接": " Add link",
  "添加": "Add",
  "正在由AI生成知识卡片…": "AI is generating the knowledge card…",
  "此主题暂无知识卡片（可能内容尚未生成，或生成失败）。": "No knowledge card for this topic (not generated yet, or generation failed).",
  "管理员已审核": "Reviewed by an admin",
  "AI 自动生成，尚未审核": "AI generated, not reviewed yet",
  "摘要": "Summary",
  "要点（每行一条）": "Key points (one per line)",
  "标签（顿号或逗号分隔）": "Tags (comma-separated)",
  " · 更新于 {0}": " · updated {0}",
  "下载 Word 文档": "Download Word document",
  "请选择左侧主题。": "Select a topic on the left.",
  "教师使用手册根据系统当前功能自动生成，涵盖课程设计的创建/编辑/保存/提交/上传/下载/删除、专家评审、AI 点评、 评审历史、AI 讨论、欣欣小助手、执行阶段支撑材料管理与模板迁移等内容。":
    "The teacher manual is generated automatically from the system's current features. It covers creating, editing, saving, submitting, uploading, downloading and deleting course designs, plus expert review, AI review, review history, AI discussion, Xinxin Assistant, implementation materials and template migration. (The manual itself is in Chinese.)",
  "下载最新教师手册": "Download the latest teacher manual",
  "发布中...": "Publishing...",
  "生成并发布到「使用指南 / 教师手册」": "Generate and publish to \"User guides / Teacher manual\"",
  "发布后将出现在下方的「使用指南 / 教师手册」主题下，教师可自行查看；再次发布会更新同一份文件。 首次发布之后，系统每次更新上线时如手册内容有变化，会自动重新发布（欣欣小助手据此回答系统使用问题）。":
    "Once published it appears under \"User guides / Teacher manual\" below for teachers to read; publishing again updates the same file. After the first publish, it's republished automatically whenever a release changes the manual (Xinxin Assistant uses it to answer how-to questions).",
  "显示导航": "Show navigation",
  "隐藏导航": "Hide navigation",
  "搜索材料库...": "Search the library...",
  "未找到相关材料。": "No matching materials.",
  "新建主题": " New topic",
  "分类（选择已有或输入新的，如：2026 或 示范资料）": "Category (choose one or type a new one, e.g. 2026 or Sample materials)",
  "主题名称": "Topic name",
  "暂无材料。": "No materials yet.",
  "选择主题": "Select a topic",

  // plan-card
  "年": "",
  "教师未知": "Unknown teacher",
  "待迁移": "Needs migration",
  "待手动整理": "Needs manual cleanup",
  "年级未定": "Grade not set",
  "{item.plannedLessonCount} 课时": "{item.plannedLessonCount} lessons",
  "课时未定": "Lessons not set",
  "已提交 {item.myReviews.submitted} 条": "{item.myReviews.submitted} submitted ",
  " · 未提交 {item.myReviews.saved} 条": " · {item.myReviews.saved} unsubmitted",
  "最近": "Latest",
  "查看点评": "View reviews",
  "查看详情": "View details",
  "取消优秀案例": "Unmark exemplary",
  "设为优秀案例": "Mark as exemplary",

  // plans-hierarchy
  "教师 #{teacherId}": "Teacher #{teacherId}",
  "加载课程设计数据失败。": "Failed to load course designs.",
  "课程设计已移入回收站。": "Course design moved to Trash.",
  "确定停用「{item.title}」吗？停用后该课程设计将从公开列表中隐藏，仅本人与管理员可见。":
    "Deactivate \"{item.title}\"? It will be hidden from public lists and visible only to its author and admins.",
  "确定取消「{teacher.teacherName}」的种子教师标记吗？": "Remove the seed-teacher flag from \"{teacher.teacherName}\"?",
  "操作成功。": "Done.",
  "搜索并选择学校（支持名称/代码）...": "Search and select a school (name / code)...",
  "只看种子教师的课程": "Seed teachers' courses only",
  "暂无课程设计": "No course designs",
  "{g.year}年": "{g.year}",
  "{selectedTeacher.teacherName} · {selectedGroup.year}年{2} · {selectedSchool.schoolName}":
    "{selectedTeacher.teacherName} · {selectedGroup.year}{2} · {selectedSchool.schoolName}",
  "选择教师": "Select a teacher",
  "请选择左侧的教师，查看其课程设计": "Select a teacher on the left to see their course designs",
  "{selectedTeacher.teacherName} 的": "{selectedTeacher.teacherName}'s ",
  "乡土课程": "courses",
  "-- {selectedGroup.year}年 ": "-- {selectedGroup.year} ",
  "（共 {selectedTeacher.plans.length} 项）": " ({selectedTeacher.plans.length} total) ",
  "取消种子教师": "Unset seed teacher",
  "设为种子教师": "Set as seed teacher",

  // plans-list
  "乡土课程设计方案模版": "Course design template",
  "课时实施记录模版": "Lesson implementation record template",
  "模板下载失败。": "Template download failed.",
  "乡土课程实施记录模版": "Implementation record template",
  "模板预览失败。": "Template preview failed.",
  "迁移完成。": "Migration complete.",
  "迁移失败。": "Migration failed.",
  "相关课程计划": "Related courses ",
  "按乡土主题与年级筛选浏览乡土课程设计。": "Browse course designs by theme and grade.",
  "总数：{totalItems}": "Total: {totalItems}",
  "当前页：{page}/": "Page {page}/",
  "（总数：{totalItems}）": " (total: {totalItems})",
  "（总数：{hierarchyFilteredCount}）": " (total: {hierarchyFilteredCount})",
  "按标题搜索": "Search by title",
  "年份筛选": "Year filter",
  "例如 2026": "e.g. 2026",
  "年级筛选": "Grade filter",
  "全部年级": "All grades",
  "有 {plansNeedingMigration.length} 个乡土课程设计使用旧版模板，点击迁移到最新模板":
    "{plansNeedingMigration.length} course designs use an old template. Click to migrate them to the latest one",
  "迁移课程计划（{plansNeedingMigration.length}）": "Migrate courses ({plansNeedingMigration.length})",
  "新增乡土课程": "New course",
  "乡土课程设计方案模版：": "Course design template: ",
  "乡土课程实施记录模版：": "Implementation record template: ",

  // plans-trash
  "加载回收站失败。": "Failed to load the Trash.",
  "已恢复。": "Restored.",
  "恢复失败。": "Restore failed.",
  "此操作将永久删除「{item.title}」及其所有附件与点评，且无法撤销。确定继续吗？":
    "This will permanently delete \"{item.title}\" with all its files and reviews, and cannot be undone. Continue?",
  "已永久删除。": "Permanently deleted.",
  "永久删除失败。": "Permanent delete failed.",
  "仅教师和管理员可使用回收站。": "Only teachers and admins can use the Trash.",
  "回收站": " Trash ",
  "已删除的课程设计会在这里保留 {retentionDays} 天，期间可随时恢复（附件与点评一并恢复）；超过 {retentionDays} 天后将自动永久删除。":
    "Deleted course designs are kept here for {retentionDays} days and can be restored at any time (files and reviews included); after {retentionDays} days they are permanently deleted. ",
  "回收站为空": "The Trash is empty",
  "课程标题": "Course title",
  "年份/学期": "Year / term",
  "删除时间": "Deleted",
  "剩余天数": "Days left",
  "{daysLeft(item.purgeAt)} 天": "{daysLeft(item.purgeAt)} days",
  "恢复": "Restore",
  "永久删除": "Delete permanently",
};
export default en;
